import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom'; // ✅ Import BrowserRouter
import './Fonts/IRANSans.css'; // ✅ Add this line to import your font styles
import { register as registerServiceWorker } from './serviceWorkerRegistration';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* ✅ Wrap your App component */}
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// The production build is served as an installable PWA.
// Development remains unchanged and does not register a service worker.
registerServiceWorker();
